module.exports = __webpack_public_path__ + "static/media/sonDT.9ff1668a.mp4";